// components/ui/field/currency-adjustment-popover.tsx
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { BaseCurrencyInput } from '../form/currency-input';
import { useState } from 'react';
import { DiffIcon } from 'lucide-react';

interface CurrencyAdjustmentPopoverProps {
  onAdjust: (value: string | null) => void;
}

export function CurrencyAdjustmentPopover({ onAdjust }: CurrencyAdjustmentPopoverProps) {
  const [adjustment, setAdjustment] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleApply = () => {
    onAdjust(adjustment);
    setAdjustment(null);
    setIsOpen(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      handleApply();
    }
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="h-9 w-9">
          <DiffIcon className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-60">
        <div className="space-y-4" onKeyDown={handleKeyDown}>
          <div className="flex flex-col gap-2">
            <label className="text-xs text-slate-600 dark:text-slate-400">Add or Subtract Amount</label>
            <BaseCurrencyInput
              value={adjustment ? parseFloat(adjustment) : null}
              onChange={(val) => setAdjustment(val)}
              allowNegativeValue={true}
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button onClick={handleApply}>Adjust</Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
